import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';

import { Subject, takeUntil } from 'rxjs';

import { MwFormUIService } from './../@services/form-ui.service';

export const MwFormSidebarComponentSelector = 'mw-form-sidebar';

@Component({
  selector: MwFormSidebarComponentSelector,
  template: `<div #container>
    <ng-content></ng-content>
  </div>`,
  styleUrls: ['./form-sidebar.component.scss'],
})
export class MwFormSidebarComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  @ViewChild('container') sidebarContainer: ElementRef;
  private readonly _unsubscribeAll$ = new Subject<void>();
  private sidebarHeight: number;
  constructor(
    private readonly uiService: MwFormUIService,
    private readonly elementRef: ElementRef
  ) {}

  ngOnDestroy(): void {
    this._unsubscribeAll$.next();
    this._unsubscribeAll$.complete();
    this.uiService.dispose(this.sidebarContainer.nativeElement);
  }

  ngOnInit(): void {
    this.uiService.rootContainerScrollTop$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((top) => {
        if (this.sidebarContainer) {
          const sidebarContainerBottom = top + this.sidebarHeight;
          const sidebarEl: HTMLElement = this.elementRef.nativeElement;
          const sidebarTotalHeight = sidebarEl.clientHeight;
          const el: HTMLElement = this.sidebarContainer.nativeElement;
          if (sidebarContainerBottom < sidebarTotalHeight) {
            el.style.marginTop = `${top}px`;
          } else {
            el.style.marginTop = `${sidebarTotalHeight - this.sidebarHeight}px`;
          }
        }
      });

    this.uiService.sidebarContainerHeight$
      .pipe(takeUntil(this._unsubscribeAll$))
      .subscribe((sidebarHeight) => (this.sidebarHeight = sidebarHeight));
  }

  ngAfterViewInit(): void {
    this.uiService.setSidebarContainer(this.sidebarContainer.nativeElement);
  }
}
